import * as React from "react";
import { withRouter, RouteComponentProps } from "react-router-dom";
import { Grid } from "components/controls/widget";
import RegistraceNovehoParu from "./RegistraceNovehoParu";
import { RouteProps } from "./routes-path";
import SeznamPartneru from "./SeznamPartneru";
import PageContent from "common/web/PageContent";

interface PartneriProps {
    clenId: number;
}

declare type Props = PartneriProps & RouteComponentProps<RouteProps>;

class Partneri extends React.PureComponent<Props> {

    render() {
        const { clenId, match } = this.props;
        const paryRootPath = `../../../../../../${match.params.lang}/evidence-clenu/pary`;
        return <PageContent titles={['Partneři(ky)']}>
            <Grid container>
                <Grid item>
                    <RegistraceNovehoParu paryRootPath={paryRootPath} />
                </Grid>
                <Grid item>
                    <SeznamPartneru clenId={clenId} paryRootPath={paryRootPath} />
                </Grid>
            </Grid>
        </PageContent>
    }
}

export default withRouter(Partneri); 
